import React from 'react';
import { Select } from 'antd';

import { useQuery } from 'react-query';
import { getBrokerListByMgid, GetBrokerListByMgidParams, MgBrokerResponse } from 'services/parametersService';

export type BrokerListProps = {
  params: GetBrokerListByMgidParams;
  disabled?: boolean;
  allowClear?: boolean;
  style?: any;
  onSelected?: (Broker:MgBrokerResponse ) => void;
};

const BrokerList = ({ params,onSelected, ...otherProps }: BrokerListProps) => {
  const { data: brokers } = useQuery(
    ['getBrokerListByMgid', params],
    () => getBrokerListByMgid(params).then((res) =>  { return res.list.filter(e => e.brokerstatus==='ACTIVE') || []}) || [])
  ;

  return (
    <Select {...otherProps}>
      {brokers?.map((broker) => (
        <Select.Option value={broker.tpidbroker} key={broker.tpidbroker}>
          {broker.brokername}
        </Select.Option>
      ))}
    </Select>
  );
};

export default BrokerList;
